import React from 'react';
import { translate } from 'react-i18next';
import { isMobile } from 'react-device-detect';

function ShariffTooltip({ t }) {
  let shariffServices = `[
    "twitter",
    "facebook",
    "linkedin",
    "xing",
    "mail",
    "info"
  ]`;

  if (isMobile) {
    shariffServices = `[
      "twitter",
      "facebook",
      "linkedin",
      "xing",
      "whatsapp",
      "threema",
      "mail",
      "info"
    ]`;
  }

  return (
    <div className="tooltip-wrapper" style={{ opacity: 1, display: 'none' }}>
      <div className="tooltip-modal">
        <h4 className="no-margin-bottom margin-top-xs">{t('shareThisPage')}</h4>
        <div
          className="shariff"
          data-orientation="vertical"
          data-theme="quirin"
          data-services={shariffServices}
          data-mail-url="mailto:"
        />
      </div>
    </div>
  );
}

ShariffTooltip.propTypes = {
  t: React.PropTypes.func
};

export default translate()(ShariffTooltip);



// WEBPACK FOOTER //
// ./components/widgets/shariffTooltip.js